import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import Header from '@/shared/components/layout/header/Header';
import Sidebar from '@/shared/components/layout/sidebar/Sidebar';
import { useUIStore } from '@/store';
import './Layout.css';

const { Content } = AntLayout;

const SIDEBAR_WIDTH_EXPANDED = 250;
const SIDEBAR_WIDTH_COLLAPSED = 80;

const Layout: React.FC = () => {
  const { sidebarCollapsed } = useUIStore();
  const sidebarWidth = sidebarCollapsed
    ? SIDEBAR_WIDTH_COLLAPSED
    : SIDEBAR_WIDTH_EXPANDED;

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      {/* Header spans full width at top */}
      <Header />

      <AntLayout>
        {/* Sidebar below header */}
        <Sidebar />

        {/* Main content area */}
        <AntLayout
          className="app-content-layout"
          style={{ marginLeft: sidebarWidth }}
        >
          <Content className="app-content">
            <div className="app-content__card">
              <Outlet />
            </div>
          </Content>
        </AntLayout>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout as React.ComponentType<Record<string, never>>;
